module.exports = __webpack_public_path__ + "img/printer.a41b32d9.svg";